import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cadeaubackground from '../../styles/img/background/cadeau-background.svg';
import PikkoPointContainer from '../../components/pikko-box/PikkoPointContainer';
import BackButton from '../../components/button/BackButton';
import { isAppPWA } from '../../utils/helper-functions';
import { FooterAccount } from '../footerAccount';

const PikkoPointLayout = ({ onBack, children }) => {
  const user = useSelector((state) => state.user);
  const isPWA = isAppPWA();
  const [selectedItem, setSelectedItem] = useState(3);
  return (
    <>
      <FooterAccount
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
      {!isPWA && <BackButton onClick={onBack} isAbsolute />}
      <div className={'promo-gift-screen bg-gradient1' + (isPWA ? ' pwa' : '')}>
        <img className="giga-backgroud-mask" src={cadeaubackground} alt="" />
        <div className="promo-gift-components">
          <PikkoPointContainer user={user} column />
          {children}
        </div>
      </div>
    </>
  );
};
export default PikkoPointLayout;
